module.exports = {"320404001":"五星街道","320404002":"永红街道","320404003":"北港街道","320404004":"西林街道","320404005":"南大街街道","320404006":"荷花池街道","320404007":"新闸街道","320404116":"邹区镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320404.json
// module id = 860
// module chunks = 0